/* eslint-disable no-constant-condition */
/* eslint-disable prettier/prettier */
import ErrorBoundary from "@/shared/components/error-boundary";
import { useState } from "react";

import CustomizeControlsAutoSaveComponent from "./CustomizeControlsAutoSaveComponent";
import CustomizeControlsTable, { NistCheckboxContext } from "./CustomizeControlsTable";
import CustomizeControlsTabs from "./CustomizeControlsTabs";
import CustomizeControlTopSection from "./CustomizeControlTopSection";

// Create a top-level context provider for showNistCheckboxes
export const CustomizeControlsProvider = ({ children }: { children: React.ReactNode }) => {
  const [showNistCheckboxes, setShowNistCheckboxes] = useState(false);
  
  return (
    <NistCheckboxContext.Provider value={{
      showCheckboxes: showNistCheckboxes,
      setShowCheckboxes: setShowNistCheckboxes
    }}>
      {children}
    </NistCheckboxContext.Provider>
  );
};

const CustomizeControls = () => {
  return (
    <ErrorBoundary fallback={null}>
      <CustomizeControlsProvider>
        <div className="h-full w-full overflow-hidden rounded-lg flex flex-col">
          <CustomizeControlTopSection />
          <CustomizeControlsTabs />
          <CustomizeControlsTable />
        </div>
        <CustomizeControlsAutoSaveComponent />
      </CustomizeControlsProvider>
    </ErrorBoundary>
  );
};

export default CustomizeControls;
